module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0b4a4faac5634692886876082f5c99c1.png";